import Mutations from '../../odata/mutations';

export default { ...new Mutations('costCentre'), ...new Mutations('costCentres') };
